export enum pacPhoneTypeEnum {
    Unknown = 0,
    Standard = 1,
    Mobile = 2,
    VOIP = 3
}